import { useRevealAnimation, useTextReveal } from "@/motion/hooks";
import DepthCard from "@/motion/DepthCard";
import { Film, Megaphone, LayoutGrid, Users } from "lucide-react";

const services = [
    { icon: Film, title: "AI Brand Films", desc: "Cinematic, story-led films crafted entirely with AI." },
    { icon: Megaphone, title: "AI UGC Ads", desc: "Native, high-converting ad creatives that feel real." },
    { icon: LayoutGrid, title: "Carousels & Short-form", desc: "Instagram carousels and scroll-stopping short-form content." },
    { icon: Users, title: "AI Creator Collaborations", desc: "Partnering with brands and creators on AI-first campaigns." },
];

export default function Services() {
    const revealRef = useRevealAnimation("fadeBlur", { children: "[data-reveal]", stagger: "base" });
    const h2Reveal = useTextReveal("chars");
    return (
        <section
            id="services"
            data-testid="services-section"
            className="relative border-b border-[color:var(--line)] py-24 md:py-36"
        >
            <div className="mx-auto max-w-[1400px] px-6 md:px-10">
                <div className="text-center">
                    <p className="text-[10px] uppercase tracking-luxe text-[color:var(--gold)]">
                        Services
                    </p>
                    <h2 ref={h2Reveal} className="font-display mt-4 text-5xl md:text-6xl">What I Make</h2>
                </div>

                <div className="mt-14 grid grid-cols-1 gap-px bg-[color:var(--line)] border border-[color:var(--line)] sm:grid-cols-2 lg:grid-cols-4">
                    {services.map((s, i) => (
                        <DepthCard
                            key={s.title}
                            data-reveal
                            data-testid={`service-${i}`}
                            className="group bg-[#030303] p-9 md:p-10 transition-colors hover:bg-[color:var(--bg-elev)]"
                        >
                            <s.icon
                                size={26}
                                strokeWidth={1.25}
                                className="text-[color:var(--gold)]"
                            />
                            <h3 className="mt-8 font-display text-3xl leading-none">{s.title}</h3>
                            <p className="mt-4 text-sm font-light leading-relaxed text-[color:var(--fg)]/60">
                                {s.desc}
                            </p>
                        </DepthCard>
                    ))}
                </div>
            </div>
        </section>
    );
}
